<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <index-table id="user-index-table" endpoint="usersIndex" title="Users" icon="supervisor_account" :can-selected="true">
                <template slot="head">
                    <index-table-head slug="isFederatedUser">Federated</index-table-head>
                    <index-table-head slug="firstName">First name</index-table-head>
                    <index-table-head slug="lastName">Last name</index-table-head>
                    <index-table-head slug="email">Email</index-table-head>
                    <index-table-head slug="isActive" class="text-center">Is active</index-table-head>
                    <index-table-head slug="compliance" :sortable="false" class="text-center">Compliance</index-table-head>
                    <index-table-head slug="dfs" :sortable="false" class="text-center">DFS</index-table-head>
                    <index-table-head slug="academy" :sortable="false" class="text-center">Academy</index-table-head>
                    <index-table-head slug="actions" :sortable="false" class="text-center"></index-table-head>
                </template>
              <md-table-row class="search">
                <md-table-cell></md-table-cell>
                <md-table-cell></md-table-cell>
                <index-table-filter-text slug="firstName"></index-table-filter-text>
                <index-table-filter-text slug="lastName"></index-table-filter-text>
                <index-table-filter-text slug="email"></index-table-filter-text>
                <index-table-filter-bool slug="isActive"></index-table-filter-bool>
                <md-table-cell></md-table-cell>
                <md-table-cell></md-table-cell>
                <md-table-cell></md-table-cell>
                <md-table-cell></md-table-cell>
              </md-table-row>
                <users-row v-for="(item, key) in items" :key="key" :item="item"/>
                <template slot="bulk-actions">
                    <md-button class="md-primary md-sm" @click="actionShowMergeModal">Merge</md-button>
                </template>
            </index-table>
        </div>
        <user-merge-modal v-if="showMergeModal"/>
    </div>
</template>

<style>
.search .md-table-cell{
  padding: 0 12px;
  border-top: none;
}
</style>


<script>
    import {mapGetters, mapMutations} from "vuex";
    import IndexTable from "../../components/Index/IndexTable";
    import IndexTableHead from "../../components/Index/IndexTableHead";
    import UsersRow from "./UsersRow";
    import UserMergeModal from "../../modals/UserMergeModal";
    import IndexTableFilterText from "@/new/components/Index/IndexTableFilterText";
    import IndexTableFilterBool from "@/new/components/Index/IndexTableFilterBool";

    export default {
        name: "Users",
        components: {UserMergeModal, UsersRow, IndexTableHead, IndexTable, IndexTableFilterText, IndexTableFilterBool},
        computed: {
            ...mapGetters('indexTable', {
                items: 'getItems',
            }),
        },
        data() {
            return {
                showMergeModal: false,
            }
        },
        methods: {
            actionShowMergeModal() {
                this.showMergeModal = true;
            },
            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.setTitlePage(this.$t('Users'));
        }
    }
</script>
